import FuseAnimate from '@fuse/core/FuseAnimate';
import { useDebounce } from '@fuse/hooks';
import { Icon, Input, Paper } from '@material-ui/core';
import * as PropTypes from 'prop-types';
import React from 'react';

const SearchBar = ({ onChange, placeholder = 'Pesquisar', className = '' }) => {
  const handleChange = useDebounce(
    (value) => {
      onChange(value);
    },
    500,
    {}
  );
  return (
    <FuseAnimate animation="transition.slideDownIn" delay={300}>
      <Paper className={`flex items-center w-full mt-20 max-w-512 px-8 py-4 rounded-8 ${className}`} elevation={1}>
        <Icon color="action">search</Icon>

        <Input
          placeholder={placeholder}
          className="flex flex-1 mx-8"
          disableUnderline
          fullWidth
          inputProps={{
            'aria-label': 'Pesquisar',
          }}
          onChange={(event) => handleChange(event.target.value)}
        />
      </Paper>
    </FuseAnimate>
  );
};

SearchBar.propTypes = {
  searchText: PropTypes.node,
  onChange: PropTypes.func,
};

SearchBar.defaultProps = {};

export default SearchBar;
